/* Built In Imports */

/* External Imports */
import { Box, Text } from '@chakra-ui/react';
import { nanoid } from 'nanoid';

/* Internal Imports */
/* Components */
import FaqContentsSt from '@ieo/Common/StyleData/FaqContentsSt';
import RenderContent from '@ieo/Sections/RenderContent';

/* Services */

/**
 * Renders the FAQ content component
 *
 * @param {object} sectionContent - Data for section
 * @param {string} region - Region for the section
 * @param {string} language - Language for the section
 * @returns {ReactElement} FAQ content component
 */

const FaqContentsWOB = ({ sectionContent, region, lang }) => {
  return (
    <Box position={'relative'}>
      <Box
        as="div"
        pb={{ base: '52px', md: '80px', lg: '120px' }}
        mx="auto"
        px={{ base: '16px' }}
        maxWidth="1036px"
        pt={{ base: '58px', md: '80px', lg: '100px' }}
      >
        <Box as="div" px={{ base: '0px', md: '15px', lg: '0px' }} pb="20px">
          <Text {...FaqContentsSt[lang].stFaText}>
            {sectionContent[0].text}
          </Text>
          <Text {...FaqContentsSt[lang].stQText} mt={"8px"}>{sectionContent[1].text}</Text>
        </Box>
        <Box
          m={{
            base: '30px 0px 0 0px',
            md: '0 15px 0 15px',
            lg: '30px 0px 0 0px',
          }}
        >
          {sectionContent[2]?.faqSections?.map(dataChild => {
            return (
              <RenderContent
                key={nanoid(2)}
                lang={lang}
                dataChild={dataChild}
              />
            );
          })}
        </Box>
      </Box>
    </Box>
  );
};

export default FaqContentsWOB;
